import { render, staticRenderFns } from "./App.vue?vue&type=template&id=125b0938&"
import script from "./App.ts?vue&type=script&lang=ts&"
export * from "./App.ts?vue&type=script&lang=ts&"
import style0 from "./styles.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports